export * from './config-geral-edit.component';
export * from './config-geral-browse.component';